<template>
  <v-row>
    <!-- bounce_rate -->
    <v-col cols="12" sm="12" md="4">
      <div class="py-7 text-center white--text blue-grey darken-2 rounded-lg">
        <span class="d-block title mb-2">معدل التردد</span>
        <v-progress-circular v-if="loading" indeterminate color="white" />
        <strong v-else class="title">{{ statistics.bounce_rate }}</strong>
      </div>
    </v-col>

    <!-- total_visitors -->
    <v-col cols="12" sm="6" md="4">
      <div class="py-7 text-center white--text cyan darken-2 rounded-lg">
        <span class="d-block title mb-2">عدد الزوار</span>
        <v-progress-circular v-if="loading" indeterminate color="white" />
        <strong v-else class="title">{{ statistics.total_visitors }}</strong>
      </div>
    </v-col>

    <!-- articles -->
    <v-col cols="12" sm="6" md="4">
      <div class="py-7 text-center white--text brown rounded-lg">
        <span class="d-block title mb-2">عدد المواد المنشورة</span>
        <v-progress-circular v-if="loading" indeterminate color="white" />
        <strong v-else class="title">{{ statistics.articles }}</strong>
      </div>
    </v-col>
  </v-row>
</template>


<script>
export default {
  name: 'numeric-statistics',
  props: ['statistics', 'loading']
}
</script>